/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum APIReasonEnum {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3,
    NUMBER_4 = 4
}


export function instanceOfAPIReasonEnum(value: any): boolean {
    for (const key in APIReasonEnum) {
        if (Object.prototype.hasOwnProperty.call(APIReasonEnum, key)) {
            if (APIReasonEnum[key as keyof typeof APIReasonEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function APIReasonEnumFromJSON(json: any): APIReasonEnum {
    return APIReasonEnumFromJSONTyped(json, false);
}

export function APIReasonEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIReasonEnum {
    return json as APIReasonEnum;
}

export function APIReasonEnumToJSON(value?: APIReasonEnum | null): any {
    return value as any;
}

